module.exports = __webpack_public_path__ + "static/img/dingbu.5ac91685.png";